import { MouseEvent } from "react";

export function SupportCategoryTag(categoryName: string) {
  return categoryName.replace(/\s+/g, "").replace("&", "").toLowerCase();
}

export function SupportCategoryTagWithHash(categoryName: string) {
  return `#${SupportCategoryTag(categoryName)}`;
}

export function ScrollToCategoryTag(event: MouseEvent, categoryName: string) {
  event.preventDefault();

  const elementHashTag = SupportCategoryTagWithHash(categoryName);
  const element = document.querySelector<HTMLElement>(elementHashTag);

  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
    window.history.pushState({}, "", elementHashTag);

    setTimeout(() => {
      element.focus();
    }, 500);
  }

  return false;
}
